/** Pied et raccourci du menu, extraits d'AppSidebar. */
import { MenuSearch } from './MenuSearch';
import type { MenuItem } from './sidebarConfig';
import { ChevronLeft, ChevronRight, Moon, ScanBarcode, Sun } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { APK_VERSION_NAME } from '@/hooks/useAutoUpdate';
import { useFeatureToggles } from '@/hooks/useFeatureToggles';
import { useTheme } from '@/hooks/useTheme';

export function TouchStockShortcut() {
  const { isFeatureEnabled } = useFeatureToggles();
  if (!isFeatureEnabled('mode_stock')) return null;
  return (
    <NavLink
      to="/mode-stock"
      className="mx-2 mb-2 flex items-center gap-3 rounded-lg bg-sidebar-primary px-3 font-semibold text-sidebar-primary-foreground"
    >
      <ScanBarcode className="h-5 w-5" />
      Mode Stock
    </NavLink>
  );
}

export function TouchThemeButton() {
  const { theme, toggleTheme, nextThemeLabel } = useTheme();
  const Icon = theme === 'light' ? Moon : Sun;
  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="flex min-h-12 w-full items-center gap-3 px-5 text-[0.9375rem] text-sidebar-foreground/90"
    >
      <Icon className="h-5 w-5" />
      {nextThemeLabel}
    </button>
  );
}

/** Pied du menu : recherche et réduction sur grand écran, thème dans le tiroir tactile. */
export function SidebarFooter({
  touch,
  collapsed,
  onToggle,
  menu,
}: {
  touch: boolean;
  collapsed: boolean;
  onToggle: () => void;
  /** Pages proposées par la recherche : menu visible, sans les rubriques verrouillées. */
  menu: readonly MenuItem[];
}) {
  return (
    <div className="border-t border-sidebar-border">
      {touch && <TouchThemeButton />}
      {!collapsed && <MenuSearch menu={menu} />}
      {!collapsed && (
        <div className="px-4 pb-1">
          <span className="font-mono text-[10px] tracking-wide text-sidebar-foreground/30">
            v{APK_VERSION_NAME}
          </span>
        </div>
      )}
      {!touch && (
        <button
          onClick={onToggle}
          className="flex w-full items-center justify-center py-3 text-sidebar-foreground/50 transition-colors hover:bg-sidebar-accent hover:text-sidebar-foreground"
        >
          {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </button>
      )}
    </div>
  );
}
